import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHistory } from "react-router-dom";
import { functions } from "../../../constants/common-functions";
import Header from "../../../components/Header";
import LeftMenu from "../../../components/LeftMenu";
import ResponseDetailDisplayModal from "./components/ResponseDetailDisplayModal";

export default function HomeBoxSpace() {

    const history = useHistory();
	
	const BUCKET_STATUS_OPEN ="OPEN";
	const BUCKET_STATUS_COMPLETED = "COMPLETED";
	const BUCKET_STATUS_OVERDUE = "OVERDUE";

    const [tasks, setTasks] = useState([]);
    const [hoveredId, setHoveredId] = useState(null);
	const [selectedResponseId, setSelectedResponseId] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [bucketStatus, setBucketStatus] = useState(BUCKET_STATUS_OPEN);

	const openResponseModal = (responseId) => {
	    setSelectedResponseId(responseId);
	    setShowModal(true);
	};

    const goTask = (responseId) => {
        history.push("/workflow/task/" + responseId);
    };

    useEffect(() => {
        loadTasks(bucketStatus);
    }, [bucketStatus]);

    const loadTasks = (thisBucketStatus) => {
        functions.getArrayFromAjax(
            "/resolutionsoftwareplatform/questionnaire/workflow/list?bucket=" + thisBucketStatus,
            setTasks,
            testResults
        );
    };

    const testResults = (results) => {
        console.log("Got stuff back");
        console.log(results);
    };

    /* ====================================================== */
    /*  STYLES                                                */
    /* ====================================================== */

    const thisContainer = {
        position: "fixed",
        display: "flex",
        flexDirection: "column",
        width: "calc(100% - 60px)",
        left: "60px",
        top: "80px",
        right: "0px"
    };

    const headerRow = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        zIndex: "300000",
        width: "100%"
    };

    const grid = {
        display: "flex",
        padding: "0 6px"
    };

    const box = {
        display: "flex",
        width: "200px",
        margin: "6px",
        background: "linear-gradient(180deg, #ffffff 0%, #f3f4f6 100%)",
        borderRadius: "8px",
        border: "1px solid rgba(0,0,0,0.06)",
        boxShadow: "0 1px 4px rgba(0,0,0,0.10)",
        padding: "6px 0",
        alignItems: "center",
		cursor:'pointer'
    };

    const label = {
        fontSize: "13px",
        flex: "1",
        paddingLeft: "10px",
        fontWeight: 500,
        color: "rgba(0,0,0,0.6)",
        paddingRight: "10px"
    };

    const figureBase = {
        height: "28px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "8px",
        fontSize: "15px",
        fontWeight: 600,
        color: "white",
        marginRight: "10px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.12)",
        width: "60px"
    };

    const redBg = {
        background: "linear-gradient(180deg, #d02632 0%, #9b1e27 100%)"
    };

    const amberBg = {
        background: "linear-gradient(180deg, #ffb44c 0%, #e0952c 100%)"
    };

    const greenBg = {
        background: "linear-gradient(180deg, #3ea45e 0%, #2f8149 100%)"
    };

    // 🔥 NEW TASK CARD STYLES

    const TASK_CARD_BASE = {
        background: "rgba(255,255,255,0.85)",
        backdropFilter: "blur(6px)",
        borderRadius: "18px",
        padding: "16px 20px",
        margin: "10px 10px 14px 10px",
        boxShadow: "0 8px 18px rgba(0,0,0,0.08)",
        border: "1px solid rgba(255,255,255,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        cursor: "pointer",
        transition: "all 0.2s ease"
    };

    const TASK_CARD_HOVER = {
        transform: "translateY(-2px)",
        boxShadow: "0 12px 24px rgba(0,0,0,0.12)"
    };

    const TASK_DATE = {
        minWidth: "110px",
        fontWeight: "600",
        color: "#333",
        fontSize: "13px"
    };

    const TASK_CONTENT = {
        flex: 1,
        paddingLeft: "12px",
        paddingRight: "12px"
    };

    const TASK_TITLE = {
        fontWeight: "600",
        fontSize: "15px",
        color: "#111"
    };

    const TASK_SUBTITLE = {
        fontSize: "13px",
        color: "#666",
        marginTop: "4px"
    };

    const TASK_DESCRIPTION = {
        fontSize: "12px",
        color: "#999",
        marginTop: "6px"
    };

	
	const boxActive = {
	    background: "linear-gradient(180deg, #1f2937 0%, #111827 100%)",
	    color: "white",
	    border: "1px solid rgba(0,0,0,0.25)",
	    boxShadow: "0 3px 8px rgba(0,0,0,0.35)",
	    transform: "translateY(-1px)"
	};

	const labelActive = {
	    color: "rgba(255,255,255,0.85)"
	};
	
	
	const overlayStyle = {
	      position: "fixed",
	      top: 0,
	      left: 0,
	      width: "100%",
	      height: "100%",

	      background: "rgba(255,255,255,0.85)",

	      pointerEvents: "none",

	      opacity: 0,
		 zIndex:1,
	      animation: "fadeOverlay 4s ease forwards"
	    };

    /* ====================================================== */
    /*  RENDER                                                */
    /* ====================================================== */

    return (
		<>
        <div style={thisContainer}>
            <Header />
            <LeftMenu />
			<div style={overlayStyle}/>
            {/* TOP COUNTS (still static – wire later) */}
            <div style={headerRow}>
                <div style={grid}>
				<div
				    style={
				        bucketStatus === BUCKET_STATUS_COMPLETED
				            ? { ...box, ...boxActive }
				            : box
				    }
				    onClick={() => setBucketStatus(BUCKET_STATUS_COMPLETED)}
				>
				    <div
				        style={
				            bucketStatus === BUCKET_STATUS_COMPLETED
				                ? { ...label, ...labelActive }
				                : label
				        }
				    >
				        Completed
				    </div>
				    <div style={{ ...figureBase, ...greenBg }}>—</div>
				</div>
				<div
				    style={
				        bucketStatus === BUCKET_STATUS_OPEN
				            ? { ...box, ...boxActive }
				            : box
				    }
				    onClick={() => setBucketStatus(BUCKET_STATUS_OPEN)}
				>
				    <div
				        style={
				            bucketStatus === BUCKET_STATUS_OPEN
				                ? { ...label, ...labelActive }
				                : label
				        }
				    >
				        Open
				    </div>
				    <div style={{ ...figureBase, ...amberBg }}>—</div>
				</div>

				<div
				    style={
				        bucketStatus === BUCKET_STATUS_OVERDUE
				            ? { ...box, ...boxActive }
				            : box
				    }
				    onClick={() => setBucketStatus(BUCKET_STATUS_OVERDUE)}
				>
				    <div
				        style={
				            bucketStatus === BUCKET_STATUS_OVERDUE
				                ? { ...label, ...labelActive }
				                : label
				        }
				    >
				        Overdue
				    </div>
				    <div style={{ ...figureBase, ...redBg }}>—</div>
				</div>

                </div>
            </div>

            {/* TASK LIST */}
            {tasks.map(function (task) {

                const isHovered = hoveredId === task.responseId;

                return (
                    <div
                        key={task.responseId}
                        style={
                            isHovered
                                ? { ...TASK_CARD_BASE, ...TASK_CARD_HOVER }
                                : TASK_CARD_BASE
                        }
						onClick={function () {
						    if (bucketStatus === BUCKET_STATUS_COMPLETED) {
						        openResponseModal(task.responseId);
						    } else {
						        goTask(task.responseId);
						    }
						}}
                        onMouseEnter={function () {
                            setHoveredId(task.responseId);
                        }}
                        onMouseLeave={function () {
                            setHoveredId(null);
                        }}
                    >

                        {/* LEFT: DATE */}
                        <div style={TASK_DATE}>
                            {task.periodEndDate}
                        </div>

                        {/* MIDDLE: CONTENT */}
                        <div style={TASK_CONTENT}>
                            <div style={TASK_TITLE}>
                                {task.title}
                            </div>

                            <div style={TASK_SUBTITLE}>
                                {task.subtitle}
                            </div>

                            
                        </div>

                    </div>
                );
            })}
        </div>
		<ResponseDetailDisplayModal
		  open={showModal}
		  onClose={function() { setShowModal(false); }}
		  onReissue={function() { /* later */ }}
		  responseId={selectedResponseId}
		/>
		</>
    );
}
